import { db, FirebaseTimestamp } from "../firebase";
import {
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  getDocs,
  where,
  startAt,
  endAt,
  limit,
} from "firebase/firestore";

/*B@社員マスタ用 */
export const getWorkersRecords = async (str) => {
  try {
    const workersRef = collection(db, "workers");
    const q = query(
      workersRef,
      where("B178_kana.value", ">=", str),
      where("B178_kana.value", "<=", str + "\uf8ff"),
      orderBy("B178_kana.value"),
      orderBy("B178_id.value")
    );
    // const q = query(
    //   workersRef,
    //   orderBy("A13_カナ検索.value"),
    //   startAt(str),
    //   endAt(str + "\uf8ff")
    // );

    const querySnapshot = await getDocs(q);

    const records = [];
    querySnapshot.forEach((doc) => {
      records.push(doc.data());
    });

    return records;
  } catch (error) {
    console.error("Error getting documents: ", error);
  }
};
/*A@社員マスタ用*/
export const getWorkersRecordsA = async (str) => {
  try {
    const workersRef = collection(db, "workersA");
    // const q = query(
    //   workersRef,
    //   where("B178_kana.value", ">=", str),
    //   where("B178_kana.value", "<=", str + "\uf8ff"),
    //   orderBy("B178_kana.value"),
    //   orderBy("B178_id.value")
    // );
    const q = query(
      workersRef,
      orderBy("A13_カナ検索.value"),
      startAt(str),
      endAt(str + "\uf8ff")
    );

    const querySnapshot = await getDocs(q);

    const records = [];
    querySnapshot.forEach((doc) => {
      records.push(doc.data());
    });

    return records;
  } catch (error) {
    console.error("Error getting documents: ", error);
  }
};

export const getWorkersRecordsByNumber = async (number) => {
  try {
    const workersRef = collection(db, "workers");
    const q = query(
      workersRef,
      where("B178_id.value", "==", number),
      orderBy("B178_id.value")
    );
    // const q = query(
    //   workersRef,
    //   orderBy("A13_カナ検索.value"),
    //   startAt(str),
    //   endAt(str + "\uf8ff")
    // );

    const querySnapshot = await getDocs(q);

    const records = [];
    querySnapshot.forEach((doc) => {
      records.push(doc.data());
    });
    return records;
  } catch (error) {
    console.error("Error getting documents: ", error);
  }
};

export const getWorkersRecordsByNumberA = async (number) => {
  try {
    const workersRef = collection(db, "workersA");
    const q = query(
      workersRef,
      where("A13_anwmcd.value", "==", number),
      orderBy("A13_anwmcd.value")
    );
    const querySnapshot = await getDocs(q);
    const records = [];
    querySnapshot.forEach((doc) => {
      records.push(doc.data());
    });

    return records;
  } catch (error) {
    console.error("Error getting documents: ", error);
  }
};

export const getUsersRecords = async (str) => {
  try {
    const workersRef = collection(db, "users");
    const q = query(
      workersRef,
      where("usernumber", ">=", str),
      where("usernumber", "<=", str + "\uf8ff"),
      orderBy("usernumber")
    );
    // const q = query(
    //   workersRef,
    //   orderBy("A13_カナ検索.value"),
    //   startAt(str),
    //   endAt(str + "\uf8ff")
    // );

    const querySnapshot = await getDocs(q);

    const records = [];
    querySnapshot.forEach((doc) => {
      records.push(doc.data());
    });

    return records;
  } catch (error) {
    console.error("Error getting documents: ", error);
  }
};

export const getWorkerInfoByEmail = async (str) => {
  try {
    const workersRef = collection(db, "workers");
    const q = query(workersRef, where("B178_gmail.value", "==", str), limit(1));

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return null; // マッチする文書がない場合はnullを返す
    }

    // 最初の文書のデータを返す
    return querySnapshot.docs[0].data();
  } catch (error) {
    console.error("Error getting document: ", error);
    throw error; // エラーを呼び出し元に伝播させる
  }
};

/**
 * usersコレクションをemailで検索し、最初の1件を返す。
 * 該当なしの場合はnullを返す。
 * 同一emailのユーザは運用上1件を前提とする(Auth.jsx, listenAuthState等も先頭1件のみ採用)。
 */
export const getUserByEmail = async (email) => {
  if (!email) return null;
  try {
    const usersRef = collection(db, "users");
    const q = query(usersRef, where("email", "==", email), limit(1));
    const querySnapshot = await getDocs(q);
    if (querySnapshot.empty) {
      return null;
    }
    const userDoc = querySnapshot.docs[0];
    return { id: userDoc.id, ...userDoc.data() };
  } catch (error) {
    console.error("Error getting user by email: ", error);
    throw error;
  }
};
